module.exports = __webpack_public_path__ + "img/calendar.0369e70d.svg";